import {Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy} from '@angular/core';
import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';
import {TermViewModel} from '../../../shared/viewModels/term.viewModel';
import {WebsiteService} from '../../../shared/services/website.service';

@Component({
    selector: 'app-contacts',
    templateUrl: './contacts.component.html',
    styleUrls: ['./contacts.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactsComponent implements OnInit {

    constructor(
    ) {
    }

    ngOnInit() {
    }

}
